import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { errorMessage } from '@/api/errors';

export function Loader({ label = 'Loading' }: { label?: string }) {
  return (
    <Box role="status" aria-label={label} sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <CircularProgress size={32} />
    </Box>
  );
}

export function FullPageLoader() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <Loader label="Loading Ehsaan CRM" />
    </Box>
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <Box sx={{ textAlign: 'center', py: 6, px: 2 }}>
      <Typography variant="h5">{title}</Typography>
      {description && (
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: 2 }}>{action}</Box>}
    </Box>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <Box role="alert" sx={{ textAlign: 'center', py: 6, px: 2 }}>
      <Typography variant="h5">Could not load this</Typography>
      <Typography color="text.secondary" sx={{ mt: 1 }}>
        {errorMessage(error)}
      </Typography>
      {onRetry && (
        <Button sx={{ mt: 2 }} variant="outlined" onClick={onRetry}>
          Try again
        </Button>
      )}
    </Box>
  );
}
